<template>
  <b-modal
    :id="`screenshotModal-${name}`"
    modal-class="screenshot-modal"
    size="lg"
    hide-header
  >
    <div class="screenshot-modal-wrapper">
      <div
        class="prev"
        @click="prevScreenshot()"
        v-if="showControls"
      >
        <i class="fa-light fa-chevron-left carousel-btn" />
      </div>
      <div
        class="screenshot-image-wrapper"
      >
        <img
          :src="content"
        >
      </div>
      <div
        class="next"
        @click="nextScreenshot()"
        v-if="showControls"
      >
        <i class="fa-light fa-chevron-right carousel-btn" />
      </div>
    </div>
    <template #modal-footer>
      <div
        class="ml-auto"
      >
        <b-button
          variant="secondary"
          @click="downloadScreenshot"
        >
          Download Image
        </b-button>
        <b-button
          class="ml-2"
          variant="primary"
          @click="closeModal"
        >
          Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
<script>

import fileHelper from '@/core/mixins/fileHelper';

export default {
  name: 'ScreenshotModal',
  components: {},
  mixins: [
    fileHelper,
  ],
  props: {
    name: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    showControls: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    downloadScreenshot() {
      this.downloadFile(this.content, this.name);
    },
    prevScreenshot() {
      this.$emit('prevScreenshot', this.name);
    },
    nextScreenshot() {
      this.$emit('nextScreenshot', this.name);
    },
    closeModal() {
      this.$bvModal.hide(`screenshotModal-${this.name}`);
    },
  },
};
</script>
<style lang="scss">
 .screenshot-modal-wrapper {
   display: flex;
   justify-content: center;
   align-content: center;
 }
 .prev, .next {
   width: 40px;
   display: flex;
   justify-content: center;
 }
 .prev:hover, .next:hover {
   background-color: $gray-100;
 }
 .screenshot-image-wrapper {
   text-align: center;
   padding: 20px 0;
   width: calc(100% - 80px);
 }
 .carousel-btn {
   display: flex;
   align-items: center;
   font-size: 40px;
 }
 .screenshot-modal .modal-content, .screenshot-modal .modal-body {
   padding: 0;
 }
 .screenshot-modal .modal-dialog footer {
   border: 0;
   padding: 20px 0;
 }
 .screenshot-modal .modal-dialog footer button {
   margin: 0 15px;
 }
</style>
